<div class="wrapper">
  <button
    class="btn-call-support"
    data-at-btn-call-support
    mat-raised-button
    color="primary"
    gtm="onGoToPage"
    gtmAction="Call Support"
    gtmCategory="serviceTicket"
    (click)="openCallPage()"
  >
    <span>{{ '+SERVICE_TOOL.CALL_SUPPORT_BTN' | translate }}</span>
    <mat-icon>call</mat-icon>
  </button>
</div>
